<template>
    <div class="action-palette" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <div class="action-palette-top">
            <div class="search-container" @click.stop>
                <a-icon
                    type="search"
                    v-if="!showSearchBar"
                    @click="toggleSearchBar"
                    :class="{ hide: showSearchBar }"
                    style="font-size: 21px"
                />
                <div class="input-wrapper">
                    <input
                        ref="searchInput"
                        type="text"
                        v-model="searchText"
                        placeholder="Search..."
                        id="action-palette-search-bar"
                        :class="{ show: showSearchBar }"
                        @keydown.enter="hideSearchBar"
                    />
                    <a-icon
                        v-if="searchText && showSearchBar"
                        type="delete"
                        @click="clearSearchText"
                        class="clear-icon"
                    />
                </div>
            </div>
            <div style="display: flex; flex-direction: row; justify-content: end">
                <a-icon style="font-size: 23px" type="close" v-if="bar !== 0" @click="$emit('close-menu', 0)" />
            </div>
        </div>
        <section v-for="(ap, i) in filteredActionPalette" :key="i" v-if="ap.enabled">
            <div class="title">
                <div class="title-content">
                    {{ $t(`chatbotv2.${ap.group.split(" ").length > 1 ? ap.group.split(" ").join("_") : ap.group}`) }}
                </div>
            </div>
            <div class="items">
                <button
                    class="item chatbot-btn"
                    v-for="item in ap.items"
                    v-if="!item.disabled"
                    :key="item.id"
                    @dragstart="(ev) => dragStart(ev, item.id)"
                    @drag="(ev) => dragStart(ev, item.id)"
                    @dragend="dragEnd()"
                    :draggable="true"
                >
                    <div>
                        <BlockIconPreview style="font-size: 24px" :block-type="item.id" class="img" />
                    </div>
                    <div class="d-flex align-items-center align-content-center justify-content-start">
                        <span class="blockTypeText">
                            {{ $t(`chatbotv2.${item.id}`).toLocaleLowerCase($i18n.locale) }}
                        </span>
                    </div>
                </button>
            </div>
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import { BlockStyles } from "../../../chatbot";
import BlockIconPreview from "../common/BlockIconPreview";

const { ActionPalette } = require("../../../chatbot");
const log = log2("ActionPalette");
export default {
    name: "ActionPalette",
    components: { BlockIconPreview },
    props: ["dragMode", "dragStart", "dragEnd", "addBlockToDiagram", "bar"],
    data() {
        return {
            cancels: [],
            showSearchBar: false,
            searchText: "",
            ActionPalette,
            BlockStyles,
            animationObject: { classes: "fadeInDown", delay: 0, duration: 300 },
            animationInfinite: {
                classes: "fadeIn",
                duration: 5000,
                iteration: "infinite",
            },
        };
    },
    computed: {
        filteredActionPalette() {
            if (!this.searchText) {
                return this.ActionPalette;
            }
            const searchTextLower = this.searchText.toLowerCase();
            return this.ActionPalette.map((group) => {
                const filteredItems = group.items.filter((item) =>
                    this.$t(`chatbotv2.${item.id}`).toLowerCase().includes(searchTextLower)
                );
                return {
                    ...group,
                    items: filteredItems,
                };
            }).filter((group) => group.items.length > 0);
        },
    },
    methods: {
        toggleSearchBar() {
            this.showSearchBar = !this.showSearchBar;
            this.$nextTick(() => {
                if (this.showSearchBar) {
                    this.$refs.searchInput.focus();
                }
            });
        },
        hideSearchBar() {
            this.showSearchBar = false;
        },
        clearSearchText() {
            this.searchText = "";
        },
        escapeKeyEvent(e) {
            if (e.key === "Escape") {
                this.hideSearchBar();
            }
        },
        enterKeyEvent(e) {
            if (e.key === "Enter") {
                this.hideSearchBar();
            }
        },
        handleOutsideClick(event) {
            const searchBar = this.$el.querySelector("#action-palette-search-bar");
            if (searchBar && !searchBar.contains(event.target)) {
                this.hideSearchBar();
            }
        },
    },
    mounted() {
        window.addEventListener("keydown", this.enterKeyEvent);
        window.addEventListener("keydown", this.escapeKeyEvent);
        document.addEventListener("click", this.handleOutsideClick);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.enterKeyEvent);
        window.removeEventListener("keydown", this.escapeKeyEvent);
        document.removeEventListener("click", this.handleOutsideClick);
    },
};
</script>

<style lang="scss" scoped>
.action-palette-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.search-container {
    display: flex;
    width: 100% !important;
    justify-content: normal;
    align-items: center;
}

.input-wrapper {
    position: relative;
    display: flex;
    width: 70%;
    align-items: center;
}

#action-palette-search-bar {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #dcdcdc;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    opacity: 0;
    transform: translateX(10px);
    transition: opacity 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    font-family: "Arial", sans-serif;
}

#action-palette-search-bar.show {
    opacity: 1;
    transform: translateX(0);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.clear-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    color: red;
    font-size: 14px;
    transition: opacity 0.3s ease;
}

a-icon {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

a-icon.hide {
    opacity: 0;
    transform: translateX(10px);
}

.action-palette {
    box-shadow: 0 4px 20px #00000040;
    background: #ffffff;
    padding: 25px;
    border-radius: 6px;
    height: 75vh;
    overflow: auto;
    width: 350px;

    section:not(:last-child) {
        margin-bottom: 1rem;
    }

    .chatbot-btn {
        border: none;
        background: #fff;
        border-radius: 4px;
        padding: 4px 8px;
        margin: 0;
        min-height: 34px;
        min-width: 34px;
        color: #000;
        display: flex;
        align-items: center;

        span {
            text-align: left;
        }
        .ai-assistant {
            svg {
                width: 20px;
                height: 20px;
                fill: #4a529e;

                g {
                    fill: #4a529e !important;
                }
            }
        }
    }

    .title {
        display: flex;
        justify-content: space-between;
        margin: 1rem 0 1.5rem 0;
        font-size: 18px;
        line-height: 18px;
        font-weight: 600;
        align-items: center;
        gap: 20px;
    }

    :nth-child(1) .title {
        margin-top: 0;
    }

    .items {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 8px;

        .item {
            transition: all 0.3s ease-in-out;
            text-transform: capitalize;
            cursor: grab;
            padding: 10px;

            span {
                color: #22272d;
                font-size: 12px;
                font-weight: 500;
                line-height: 12px;
            }

            .img {
                min-width: 40px;
                height: 40px;
                border-radius: 4px;
                background-color: #06a9f3;
                margin-right: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                &[data-type="FEEDBACK_AI_ASSISTANT"] {
                    background: linear-gradient(162deg,#4b6ae5,#0031f6) !important;
                }

                &[data-type="START_POINT"] {
                    color: #fff;
                    background-color: #566e8a !important;
                }

                &[data-type="DEFAULT_FALLBACK"] {
                    color: #fff;
                    background-color: #797b8c !important;
                }

                &[data-type="DEFAULT_TIMEOUT"] {
                    color: #fff;
                    background-color: #d2ba69 !important;
                }

                &[data-type="AI_FUNCTIONS"] {
                    color: #fff;
                    background-color: linear-gradient(90deg, #00c6ff 0%, #0072ff 100%) !important;
                }

                &[data-type="TIMEOUT"] {
                    color: #fff;
                    background-color: #d2ba69 !important;
                }

                &[data-type="BOT_RESPONSE"] {
                    color: #647283;
                    background-color: #f5f5f5 !important;
                    transform: rotate(0deg) !important;
                }

                &[data-type="FALLBACK"] {
                    color: #ffffff;
                    background-color: #797b8c !important;
                }

                &[data-type="FILTER"] {
                    color: #fff;
                    background-color: #686ad3 !important;
                }

                &[data-type="FLOW"] {
                    color: #000;
                    background-color: #b3d6ff !important;
                }

                &[data-type="ATTACHMENT_INPUT"] {
                    color: #647283;
                    background-color: #e7e4e4 !important;
                    transform: rotate(0deg) !important;
                }

                &[data-type="USER_INPUT"] {
                    color: #59687b;
                    background-color: #c9d3de !important;
                }

                &[data-type="GO_TO_STEP"] {
                    transform: rotate(90deg);
                    color: #000;
                    background-color: #ffdc67 !important;
                }

                &[data-type="ADD_TO_SEGMENT"] {
                    transform: rotate(90deg);
                    color: #22314a;
                    background-color: #9ccb80 !important;
                }

                &[data-type="REMOVE_FROM_SEGMENT"] {
                    transform: rotate(90deg);
                    color: #22314a;
                    background-color: #f5f5f5 !important;
                }

                &[data-type="WEBHOOK"] {
                    color: #fff;
                    background-color: #40455b !important;
                }

                &[data-type="API_REQUEST"] {
                    color: #fff;
                    background-color: #40455b !important;
                }

                &[data-type="SET_ATTRIBUTE"] {
                    color: #fff;
                    background-color: #6e5b8c !important;
                }

                &[data-type="ASSIGN_OWNER"] {
                    color: #fff;
                    background-color: #6e5b8c !important;
                }

                &[data-type="QUESTION"] {
                    color: #000;
                    background-color: #ffad5c !important;
                }

                &[data-type="CLOSE_CHAT"] {
                    color: #000;
                    background-color: #f5f5f5 !important;
                }

                &[data-type="CLOSE_CHAT"] {
                    color: #ffffff;
                    background-color: #ad6fe9 !important;
                }

                &[data-type="TRANSFER_CHAT"] {
                    color: #000;
                    background-color: #76e394 !important;
                }
                &[data-type="TRANSFER_TO_CHATBOT"] {
                    color: #fff;
                    background-color: #ff00ca !important;
                }

                &[data-type="TAG_CHAT"] {
                    color: #000;
                    background-color: #eded67 !important;
                }

                &[data-type="REMOVE_TAG"] {
                    color: #000;
                    background-color: #eded67 !important;
                }

                &[data-type="SEND_TRANSCRIPT"] {
                    color: #ffffff;
                    background-color: #4959da !important;
                }

                &[data-type="SEND_SMS"] {
                    color: #ffffff;
                    background-color: #4959da !important;
                }

                &[data-type="OTP_SMS_FLOW"] {
                    color: #ffffff;
                    background-color: #4959da !important;
                }

                &[data-type="SEND_MAIL"],
                &[data-type="TABLE_CREATE_RECORD"],
                &[data-type="TABLE_DELETE_RECORD"],
                &[data-type="TABLE_UPDATE_RECORD"],
                &[data-type="TABLE_FIND_RECORD"],
                &[data-type="TABLE_FIND_RECORDS"] {
                    color: #ffffff;
                    background-color: #ff7a1f !important;
                }

                &[data-type="OTP_MAIL_FLOW"] {
                    color: #ffffff;
                    background-color: #ff7a1f !important;
                }

                &[data-type="CREATE_EVENT"] {
                    color: #ffffff;
                    background-color: #033c7c !important;
                }

                &[data-type="CREATE_RESERVATION"] {
                    color: #ffffff;
                    background-color: #235603 !important;
                }

                &[data-type="RESERVATION_OPEN_URL"] {
                    color: #ffffff;
                    background-color: #235603 !important;
                }
                &[data-type="RESERVATION_SELECT_DAY"] {
                    color: #ffffff;
                    background-color: #235603 !important;
                }
                &[data-type="RESERVATION_SELECT_TIME"] {
                    color: #ffffff;
                    background-color: #235603 !important;
                }

                &[data-type="RESERVATION_EVENT_LIST"] {
                    color: #ffffff;
                    background-color: #235603 !important;
                }

                &[data-type="SUPPRESSION_ADD"] {
                    color: #ffffff;
                    background-color: #9d2126 !important;
                }

                &[data-type="ZOHO_CREATE_RECORD"],
                &[data-type="HOLIDAY_PLUS_GET_HOTELS"],
                &[data-type="HOLIDAY_PLUS_GET_ROOMS"] {
                    color: #ffffff;
                    background-color: #82d1b2 !important;
                }

                &[data-type="INSTAGRAM_COMMENT_REPLY"],
                &[data-type="INSTAGRAM_COMMENT_DELETE"],
                &[data-type="INSTAGRAM_COMMENT_SHOW"],
                &[data-type="INSTAGRAM_COMMENT_HIDE"],
                &[data-type="AI_INSTAGRAM_FLOW"],
                &[data-type="INSTAGRAM_COMMENT_REPLY_AS_PRIVATE"] {
                    color: #ffffff;
                    background: #833ab4 !important;
                    background: linear-gradient(to right, #833ab4, #fd1d1d, #fcb045) !important;
                }

                &[data-type="SUPPRESSION_REMOVE"] {
                    color: #ffffff;
                    background-color: #9d2126 !important;
                }

                &[data-type="SEND_WP_BUSINESS_MESSAGE"] {
                    color: #fff;
                    background-color: #4ee82f !important;
                }

                &[data-type="OTP_WHATSAPP_FLOW"] {
                    color: #fff;
                    background-color: #4ee82f !important;
                }

                &[data-type="SUCCESS"] {
                    color: #00c800;
                    background-color: #fff !important;
                }

                &[data-type="FAILURE"] {
                    color: #ff0000;
                    background-color: #fff !important;
                }

                &[data-type="PLATFORM_FLOW"] {
                    color: #000000;
                    background-color: #1ed4e5 !important;
                }
            }

            &:hover {
                box-shadow: 0 4px 10px #00000040;
            }
        }
    }
}
</style>
